import useGlobalDebounceHandler from "@/hooks/useGlobalDebounce";
import { handleGlobalGetRequestQuery } from "@/lib/httpFunction/globalApiFunction";
import { IGetServicePropsSchema } from "@/services/global_services.types";
import { QUERY_KEYS } from "@/services/KEYS/QUERY_KEYS";
import { CORE_URLS } from "@/services/URLS/CORE_URLS";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { IIFSCServiceResponseSchema } from "./ifsc.types";

export const useIfscService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  filters,
  cacheKeys = [],
}: IGetServicePropsSchema) => {
  const [ifscQuery, setIfscQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(ifscQuery);

  const getAllIfscService = useQuery({
    queryKey: [
      ...QUERY_KEYS.IFSC,
      debouncedQuery,
      page,
      per_page,
      ...cacheKeys,
    ],
    queryFn: (): Promise<{ data: IIFSCServiceResponseSchema[] }> =>
      handleGlobalGetRequestQuery({
        url: CORE_URLS.IFSC,
        searchParams: {
          search_value: debouncedQuery,
          ...filters,
          per_page: per_page,
          page: page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: {
      getAllIfscService,
    },
    states: {
      ifscQuery,
      setIfscQuery,
    },
  };
};
